import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { View } from "./view";
import { useNavigate } from "react-router-dom";
import { UseUserConfirmEmail } from "../../fnx/user/userConfirmEmail";
import { position, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import showToast from "../../services/toast";
import Logo from "../../assets/images/logoAffinity.svg";
export var ConfirmEmail = function () {
    var navigate = useNavigate();
    var _a = useState(false), trigger = _a[0], setTrigger = _a[1];
    var _b = useState({
        userName: "",
        code: "",
    }), bodyRequest = _b[0], setBodyRequest = _b[1];
    var _c = UseUserConfirmEmail(trigger, bodyRequest), responseConfirmEmail = _c.responseConfirmEmail, errorConfirmEmail = _c.errorConfirmEmail, loadingConfirmEmail = _c.loadingConfirmEmail;
    var _d = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _d[0], setSeeToast = _d[1];
    useEffect(function () {
        if (responseConfirmEmail && (responseConfirmEmail === null || responseConfirmEmail === void 0 ? void 0 : responseConfirmEmail.length) > 0) {
            setTrigger(false);
            navigate("/login");
        }
    }, [responseConfirmEmail]);
    useEffect(function () {
        var _a, _b, _c;
        if (errorConfirmEmail) {
            var error = errorConfirmEmail;
            var message = "Error al confirmar correo electrónico";
            if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.errors) !== undefined) {
                message = (_b = error.response) === null || _b === void 0 ? void 0 : _b.errors[0].message;
            }
            else {
                message = (_c = error.response) === null || _c === void 0 ? void 0 : _c.message;
            }
            setSeeToast({
                show: true,
                message: message,
                type: typeAlert.error,
            });
            setTrigger(false);
        }
    }, [errorConfirmEmail]);
    var handleSubmit = function (dataItem) {
        setBodyRequest({ userName: dataItem.email, code: dataItem.code });
        setTrigger(true);
    };
    return (_jsxs(React.Fragment, { children: [seeToast.show &&
                showToast(position.topRight, seeToast.type, seeToast.message, function () { return setSeeToast({ show: false, message: "", type: typeAlert.success }); }), _jsx(View, { title: "Confirmar correo electr\u00F3nico", subTitle: "Ingrese el codigo enviado por correo electr\u00F3nico", emailText: "Correo electr\u00F3nico", logo: Logo, emailPlaceHolder: "Ingresa un Usuario", emailRequired: "El correo electr\u00F3nico es requerido", emailError: "Formato de correo no aceptado", emailHelperText: "Ingrese su correo electr\u00F3nico", codeText: "Codigo", codeRequired: "El codigo es requerido", codeHelperText: "Ingrese su codigo", btnColor: "#fffff", buttonText: "Confirmar correo", userForm: "ConfirmEmail", onSaveData: handleSubmit })] }));
};
export default ConfirmEmail;
